module.exports = __webpack_public_path__ + "img/PAPARA.03d2f5a2.png";